import React from 'react'
import { Field, Form, FormElement } from '@progress/kendo-react-form';
import {
  FormNumericTextBox,
} from "src/shared/components/formControls";
import { required } from 'src/shared/validators/validators';
import FormInput from 'src/shared/components/forms/FormInput';
import WarehousesDropdown from 'src/shared/components/dropdowns/WarehousesDropdown';
import ProductsDropdown from 'src/shared/components/dropdowns/ProductsDropdown';
import UnitOfMeasureTelerikDropdown from '../../../../shared/components/dropdowns/UnitOfMeasureTelerikDropdown';
import LocationsDropdown from '../../../../shared/components/dropdowns/LocationsDropdown';
import CustomerDropdown from '../../../../shared/components/dropdowns/CustomerDropdown';
import { Button } from '@progress/kendo-react-buttons';
import { bulkUpdateInventoryUnits } from 'src/fetch/inventoryUnit';
import FormCounter from '../../../../shared/components/formControls/FormCounter';
import toastr from 'shared/helpers/toastr';

const InventoryUnitMultipleAddForm = ({
  onClose,
  orderId
}) => {

  const handleSubmit = data => {
    const inventoryUnits = Array(data.count).fill(({
      warehouseId: data.warehouseId.id,
      po: data.po,
      productId: data.productId.value,
      masterQuantity: data.masterQuantity,
      masterUomId: data.masterUomId.value,
      secondaryQuantity: data.secondaryQuantity,
      secondaryUomId: data.secondaryUomId.value,
      weight: data.weight,
      consigneeId: data.consigneeId.id,
      orderId: orderId,
      customerId: data.customerId.value,
      billToId: data.billToId.value
    }));

    const updateObject = {
      newEntities: inventoryUnits
    }

    console.log(updateObject);

    bulkUpdateInventoryUnits(updateObject).then(() => {
      toastr('success', 'Line Items Saved Successfully.');
      onClose();
    })
  };
  return (
    <Form
      onSubmit={handleSubmit}
      id='inventory-unit-multiple-add-form'
      ignoreModified={true}
      render={(formRenderProps) => (
        <FormElement>

          <div className={'fieldset-item'}>
            <div>
              <Field id={'count'} name={'count'} label={'Count'} component={FormCounter} validator={required} />
            </div>
            <div style={{ marginLeft: '1rem', marginTop: '14px' }}>
              <Field id={'billToId'} name={'billToId'} label={'Bill To'} component={CustomerDropdown} validator={required} />
            </div>
          </div>
          <div >
            <div className={'fieldset-item'} style={{ marginTop: '30px' }}>
              <div>
                <Field id={'warehouseId'} name={'warehouseId'} label={'Warehouse'} component={WarehousesDropdown} validator={required} />
              </div>
              <div style={{ marginLeft: '1rem', marginTop: '1px' }}>
                <Field id={'po'} name={'po'} label={'MR PO'} component={FormInput} validator={required} />
              </div>
            </div>

            <div className={'fieldset-item'} style={{ marginTop: '30px' }}>
              <div style={{ marginTop: '1px' }}>
                <Field id={'productId'} name={'productId'} label={'Product Code'} component={ProductsDropdown} validator={required} />
              </div>
              <div style={{ marginLeft: '1rem', marginTop: '1px' }}>
                <Field id={'customerId'} name={'customerId'} label={'Customer'} component={CustomerDropdown} validator={required} />
              </div>
            </div>

            <div className={'fieldset-item'} style={{ marginTop: '30px' }}>
              <div>
                <Field id={'masterQuantity'} name={'masterQuantity'} label={'Master Qty'} min={1} useGrouping={false} component={FormNumericTextBox} validator={required} />
              </div>
              <div style={{ marginLeft: '1rem', marginTop: '0px' }}>
                <Field id={'masterUomId'} name={'masterUomId'} label={'Master UOM'} component={UnitOfMeasureTelerikDropdown} validator={required} />
              </div>
            </div>

            <div className={'fieldset-item'} style={{ marginTop: '30px' }}>
              <div style={{ marginTop: '0px' }}>
                <Field id={'secondaryQuantity'} name={'secondaryQuantity'} label={'Secondary Qty'} min={1} useGrouping={false}  component={FormNumericTextBox} validator={required} />
              </div>
              <div style={{ marginLeft: '1rem', marginTop: '0px' }}>
                <Field id={'secondaryUomId'} name={'secondaryUomId'} label={'Secondary UOM'} component={UnitOfMeasureTelerikDropdown} validator={required} />
              </div>
            </div>

            <div className={'fieldset-item'} style={{ marginTop: '30px' }}>
              <div>
                <Field id={'weight'} name={'weight'} label={'Weight'} min={1} component={FormNumericTextBox} validator={required} />
              </div>
              <div style={{ marginLeft: '1rem', marginTop: '0px' }}>
                <div>Consignee</div>
                <Field id={'consigneeId'} name={'consigneeId'} min={1} component={LocationsDropdown} validator={required} />
              </div>
            </div>
          </div>
          <div className="k-form-buttons">
            <Button primary icon="cancel" onClick={onClose} style={{ marginRight: '10px' }}>Cancel</Button>
            <Button type='submit' icon='save' primary style={{ marginTop: '0px' }}>Save</Button>
          </div>

        </FormElement>
      )} />
  );
};

export default InventoryUnitMultipleAddForm;